/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-icon {
  height: 1.25em;
  padding-left: var(--qds-text-icon-gap);
  vertical-align: middle;
}

.qds-inline-link {
  border-radius: var(--qds-focus-border-radius);
  display: inline-block;

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }
}

.qds-disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-importance='subdued'] {
  color: var(--qds-theme-link-subdued-default);

  &:visited {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-subdued-hover);
  }

  &:active {
    color: var(--qds-theme-link-subdued-pressed);
  }

  &:visited:hover {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='standard'] {
  color: var(--qds-theme-link-standard-default);

  &:visited {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-standard-hover);
  }

  &:active {
    color: var(--qds-theme-link-standard-pressed);
  }

  &:visited:hover {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='emphasized'] {
  color: var(--qds-theme-link-emphasized-default);

  &:visited {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-emphasized-hover);
  }

  &:active {
    color: var(--qds-theme-link-emphasized-pressed);
  }

  &:visited:hover {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active {
    color: var(--qds-theme-link-visited-pressed);
  }
}
